import { useI18n } from 'i18n-utils'
import { useEnvStore } from './use-env'
import { useUserInfoStore } from './use-user-info'

export const useGlobalEventStore = defineStore('globalEventStore', () => {
  const isShowService = ref(false)
  const envStore = useEnvStore()
  const { locale } = useI18n()
  const userStore = useUserInfoStore()
  const visibility = ref<'hidden' | 'maximized'>('hidden')

  const onToggleServe = (): void => {
    isShowService.value = !isShowService.value
  }

  const getIframeUrl = computed(() => {
    const domain = envStore.config?.customerServiceUrl
    const token = userStore?.token
    const host = envStore.config?.customerType
    const lang = locale.value || 'en_US'
    return `${domain}?token=${token}&host=${host}&lang=${lang}#is_${isShowService.value ? 'show' : 'hide'}`
  })

  const openCustomerService = (): void => {
    isShowService.value = true
    visibility.value = 'maximized'
  }

  const closeCustomerService = (): void => {
    isShowService.value = false
    visibility.value = 'hidden'
  }

  const onVisibilityChange = (_visibility: 'hidden' | 'maximized'): void => {
    visibility.value = _visibility
  }

  return {
    isShowService,
    onToggleServe,
    getIframeUrl,
    openCustomerService,
    closeCustomerService,
    visibility,
    onVisibilityChange,
  }
})
